import { Component } from '@angular/core';
import { WhatsappForBusinessService } from '../../../../../services/whatsapp-for-business.service';
import { HelpersService } from '../../../../../services/helpers.service';

@Component({
  selector: 'app-whatsapp-playground',
  templateUrl: './whatsapp-playground.component.html',
  styleUrls: ['./whatsapp-playground.component.scss']
})
export class WhatsappPlaygroundComponent {


  public busy: boolean = false;
  public messageTemplates : any = [];
  public selectedMessageTemplate : any = null;
  public destinationNumber : string = null;
  public freeText : string = null;

  constructor(
    private whatsappForBusinessService : WhatsappForBusinessService,
    private helpersService : HelpersService
  ){

  }

  ngOnInit() {
    this.getMessageTemplates();    
  }

  getMessageTemplates(){
    this.whatsappForBusinessService.getWhatsAppMessageTemplates(this.helpersService.getPartnerId()).subscribe(res=>{
      this.messageTemplates = res.data;
    })
  }

  sendMessage(){
    this.busy = true;
    this.whatsappForBusinessService.sendWhatsAppMessage(this.helpersService.getPartnerId(), this.destinationNumber, this.freeText, this.selectedMessageTemplate ? this.selectedMessageTemplate.name : null, this.selectedMessageTemplate ? this.selectedMessageTemplate.language : null).subscribe(res=>{
      this.busy = false;
    },err=>{
      this.busy = false;
    });
  }

  syncTemplates(){
    this.busy = true;
    this.whatsappForBusinessService.syncTemplatesToWhatsapp(this.helpersService.getPartnerId()).subscribe(res=>{
      this.busy = false;
    },err=>{
      this.busy = false;
    });
  }

}
